module.exports = __webpack_public_path__ + "img/download-on-the-app-store-en.2928664f.svg";